
import apis, { endpoints } from '../../../api';

import {
    getHeaderOption,
} from '../../factory';

export function oauthAPI ({ store, token, traceId, body }) {
    return apis.post(
        endpoints().login,
        body,
        {
            token,
            traceId,
        },
        store
    );
}


export function renewAPI ({store, body }) {
    const {
        token,
        traceId,
    } = getHeaderOption();

    return apis.post(
        endpoints().authors + '/renewToken',
        body,
        {
            token,
            traceId,
        },
        store
    );
}

/* device score data */

const contentName = 'anyare-auth';

export function getAuthData () {
    let authInfo = {};
    const jsonData = sessionStorage.getItem(contentName);
    if (!jsonData) {
        sessionStorage.setItem(contentName, JSON.stringify(authInfo));
        return authInfo;
    }

    try {
        authInfo = JSON.parse(jsonData);
    } catch (err) {
        // force create new...
        sessionStorage.setItem(contentName, JSON.stringify(authInfo));
    }
   
    return authInfo;
}
 
export function persistAuth ({ token, payload , refreshToken, }) {
   const authInfo = getAuthData();
   authInfo.token = token;
   authInfo.payload = payload;
   authInfo.refreshToken = refreshToken;
   sessionStorage.setItem(contentName, JSON.stringify(authInfo));
}
